angular.module('zc.projects')

.directive 'zcCampaignIncentiveError', ($translate, maxIncentiveInterval) ->
  restrict: 'E'
  scope:
    campaign: '=?'
    isValid: '=?'
  template: """
  <div
    style="font-size: 1.2em;"
    class="alert alert-danger"
    role="alert"
    ng-repeat="message in messages">
    <span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
    {{message}}
  </div>
  """

  link: (scope, element, attrs) ->
    scope.messages = []

    # NOTE: should be exactly the same logic as
    # app/models/campaign.rb
    checkErrors = ->
      return unless scope.campaign.incentives and scope.campaign.start_at_obj and scope.campaign.end_at_obj
      scope.messages = []
      incentiveEndBeforeCampaignStart = false
      for incentive, i in scope.campaign.incentives
        prev_incentive = scope.campaign.incentives[i-1]
        if scope.campaign.start_at_obj && incentive.end_at < new Date(scope.campaign.start_at_obj.date)
          incentiveEndBeforeCampaignStart = true
      if incentiveEndBeforeCampaignStart
        scope.messages.push $translate.instant('projectsCampaigns.directives.campaignIncentiveError.errorIncentiveTiming')

      scope.isValid = !scope.messages.length && (!scope.campaign.requires_incentives ||      
        scope.campaign.incentive_ids.length > 0)

    checkErrors()
    scope.$watch 'campaign', checkErrors, true



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.campaigns/directives/campaign_incentive_error.directive.coffee